import React, { useState } from 'react'
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import MobileMenu2 from '../MobileMenu2/MobileMenu2'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import Logo from '../../images/logo-2.png'
import pr1 from '../../images/resource/post-thumb-1.jpg'
import pr2 from '../../images/resource/post-thumb-2.jpg'
import pr3 from '../../images/resource/post-thumb-3.jpg'


const Header4 = (props) => {
    const [searchActive, setSearchState] = useState(false);
    const [cartActive, setCartState] = useState(false);

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header className="main-header header-two">
            <div className="header-top">
                <div className="auto-container">
                    <div className="d-flex justify-content-end">
                        <div className="header-top_socials">
                            <NavLink to="/home-3" className="facebook fi flaticon-facebook"></NavLink>
                            <NavLink to="/home-3" className="twitter fi flaticon-twitter"></NavLink>
                            <NavLink to="/home-3" className="twitter fi flaticon-instagram"></NavLink>
                            <NavLink to="/home-3" className="youtube fi flaticon-youtube"></NavLink>
                        </div>
                    </div>
                </div>
            </div>
            {/* Header Upper */}
            <div className="header-upper">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">

                            <div className="logo-box">
                                <div className="logo"><NavLink onClick={ClickHandler} to="/home"><img src={Logo} alt="" title="" /></NavLink></div>
                            </div>

                            <div className="nav-outer">
                                {/* Main Menu */}
                                <nav className="main-menu navbar-expand-md">
                                    <div className="navbar-header">
                                        {/* Toggle Button */}
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                        </button>
                                    </div>

                                    <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                                        <ul className="navigation clearfix">
                                            <li><Link activeClass="active" to="home" spy={true} smooth={true} duration={500} offset={-100}>Home</Link></li>
                                            <li><Link activeClass="active" to="about" spy={true} smooth={true} duration={500} offset={-130}>About Us</Link></li>
                                            <li><Link activeClass="active" to="speakers" spy={true} smooth={true} duration={500} offset={0}>Speakers</Link></li>
                                            <li><Link activeClass="active" to="events" spy={true} smooth={true} duration={500} offset={-100}>Events</Link></li>
                                            <li><Link activeClass="active" to="blog" spy={true} smooth={true} duration={500} offset={-100}>Blog</Link></li>
                                            <li><NavLink activeClass="active" to="/contact#contact" spy={true} smooth={true} duration={500} offset={-100}>Contact</NavLink></li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>

                            {/* Main Menu End*/}
                            <div className="outer-box d-flex align-items-center flex-wrap">

                                {/* Search Btn */}
                                <div className="search-box-btn search-box-outer" onClick={() => setSearchState(!searchActive)}><span className="icon fa fa-search"></span></div>

                                {/* Nav Btn */}
                                <div className="nav-btn navSidebar-button" onClick={() => setCartState(!cartActive)}><i className='fi flaticon-shopping-cart'></i></div>

                                <div className="appointmeny_button-box">
                                    <NavLink onClick={ClickHandler} to="/register" className="theme-btn btn-style-one">
                                        <span className="btn-wrap">
                                            <span className="text-one">Claim Your Invite</span>
                                            <span className="text-two">Claim Your Invite</span>
                                        </span>
                                    </NavLink>
                                </div>

                                {/* Mobile Navigation Toggler */}
                                <MobileMenu2 />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*End Header Upper*/}
            <div className={`${searchActive ? "search-active" : ""}`}>
                <div className="search-popup">
                    <div className="color-layer"></div>
                    <button className="close-search" onClick={() => setSearchState(!searchActive)}><span className="flaticon-cancel-1"></span></button>
                    <form method="post" onSubmit={SubmitHandler}>
                        <div className="form-group">
                            <input type="search" name="search-field" placeholder="Search Here" required="" />
                            <button className="fa fa-solid fa-magnifying-glass fa-fw" type="submit"></button>
                        </div>
                    </form>
                </div>
            </div>
            <div className={`xs-sidebar-group info-group ${cartActive ? "isActive" : ""}`}>
                <div className="xs-overlay xs-bg-black" onClick={() => setCartState(!cartActive)}></div>
                <div className="xs-sidebar-widget">
                    <div className="sidebar-widget-container">
                        <div className="close-button" onClick={() => setCartState(!cartActive)}>
                            <span className="flaticon-cancel-1"></span>
                        </div>
                        <div className="sidebar-textwidget">
                            <div className="sidebar-info-contents">
                                <div className="content-inner">
                                    <div className="title-box">
                                        <h5>Shopping <span>Bag</span></h5>
                                        <div className="price">$15 from free economy shipping</div>
                                    </div>
                                    <div className="empty-cart-box">
                                        <div className="no-cart">
                                            <span className="icon"><i className='fi flaticon-shopping-cart'></i></span>
                                            No products in cart.
                                        </div>
                                    </div>

                                    <div className="lower-box">
                                        <h5>Popular <span>Suggestions</span></h5>
                                        <div className="post-block">
                                            <div className="inner-box">
                                                <div className="image">
                                                    <img src={pr1} alt="" />
                                                </div>
                                                <h6><NavLink to="/">Children Event</NavLink></h6>
                                                <div className="rating">
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                </div>
                                                <div className="price-box">$125</div>
                                                <NavLink className="theme-btn bag-btn" to="/">add to bag</NavLink>
                                            </div>
                                        </div>
                                        <div className="post-block">
                                            <div className="inner-box">
                                                <div className="image">
                                                    <img src={pr2} alt="" />
                                                </div>
                                                <h6><NavLink to="/">Marriage Caremoney</NavLink></h6>
                                                <div className="rating">
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                </div>
                                                <div className="price-box">$205</div>
                                                <NavLink className="theme-btn bag-btn" to="/">add to bag</NavLink>
                                            </div>
                                        </div>
                                        <div className="post-block">
                                            <div className="inner-box">
                                                <div className="image">
                                                    <img src={pr3} alt="" />
                                                </div>
                                                <h6><NavLink to="/">baby shower</NavLink></h6>
                                                <div className="rating">
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                    <span className="fa fa-star"></span>
                                                </div>
                                                <div className="price-box">$125</div>
                                                <NavLink className="theme-btn bag-btn" to="/">add to bag</NavLink>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </header>
    )
}

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(Header4);